import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=10e4688a"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports